import "@hotwired/turbo-rails";

import { Application } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";
import { registerControllers } from "stimulus-vite-helpers";

window.bootstrap = bootstrap;

const application = Application.start();
const controllers = import.meta.glob("./controllers/**/*.ts", {
  eager: true
});

registerControllers(application, controllers);
